import { OnInit, Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
    selector: 'invoice-details',
    templateUrl: './invoice-details.component.html',
    styleUrls: ['./invoice-details.component.scss']
  })
  export class InvoiceDetailsComponent implements OnInit {

    public _readonly: boolean;
    @Input() set readonly(value: boolean) {
        this._readonly = value;
    }


    @Input() name;
    @Input() surname;
    @Input() id;
    @Input() tax_number;
    @Input() country;
    @Input() city;
    @Input() street;
    @Input() street_number;
    @Input() apartment_number;
    @Input() postal_code;
    @Input() show_controls;
    @Input() selectedInvoiceDetailsId;

    constructor(){}

    ngOnInit(): void {}

    public onEditButton(id){
        console.log(id);
    }

    @Output() removeItem: EventEmitter<string> = new EventEmitter();
    public remove(){
        this.removeItem.emit();
    }

    @Output() editItem: EventEmitter<string> = new EventEmitter();
    public edit(){
        this.editItem.emit();
    }
  }